export const ADD_PERMISSION_TO_TEAM = 'ADD_PERMISSION_TO_TEAM';
export const ADD_PERMISSION_TO_TEAM_SUCCESS = 'ADD_PERMISSION_TO_TEAM_SUCCESS';
export const ADD_PERMISSION_TO_TEAM_FAIL = 'ADD_PERMISSION_TO_TEAM_FAIL';

export const DELETE_PERMISSION_FROM_TEAM = 'DELETE_PERMISSION_FROM_TEAM';
export const DELETE_PERMISSION_FROM_TEAM_SUCCESS =
    'DELETE_PERMISSION_FROM_TEAM_SUCCESS';
export const DELETE_PERMISSION_FROM_TEAM_FAIL =
    'DELETE_PERMISSION_FROM_TEAM_FAIL';
